module.exports = __webpack_public_path__ + "img/service1-04.4b2a77ee.png";